import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Darttemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to Dart",
        content: [
        "Overview of Dart",
        "Features of Dart",
        "Setting up the Dart environment",
        "Dart syntax and basic constructs",
        "Hello World in Dart"
        ]
        },
        {
        title: "Dart Data Types",
        content: [
        "Primitive data types in Dart",
        "Strings and string operations",
        "Collections in Dart",
        "Maps and Sets",
        "Working with Lists"
        ]
        },
        {
        title: "Dart Control Flow",
        content: [
        "Conditional statements in Dart",
        "Loops in Dart",
        "Breaking and continuing loops",
        "Switch statements in Dart",
        "Error handling with try-catch"
        ]
        },
        {
        title: "Dart Functions",
        content: [
        "Functions in Dart",
        "Function parameters",
        "Default and optional parameters",
        "Arrow functions in Dart",
        "Closures in Dart"
        ]
        },
        {
        title: "Object-Oriented Programming in Dart",
        content: [
        "Introduction to OOP in Dart",
        "Classes and objects",
        "Constructors in Dart",
        "Inheritance in Dart",
        "Abstract classes and interfaces"
        ]
        },
        {
        title: "Asynchronous Programming in Dart",
        content: [
        "Asynchronous programming in Dart",
        "Futures in Dart",
        "Async and await keywords",
        "Handling errors in asynchronous code",
        "Streams in Dart"
        ]
        },
        {
        title: "Dart Libraries and Packages",
        content: [
        "Dart libraries",
        "Creating custom libraries",
        "Using external packages in Dart",
        "Pub package manager",
        "Creating and publishing packages"
        ]
        },
        {
        title: "Web Development with Dart",
        content: [
        "Introduction to web development with Dart",
        "Building web applications with Dart",
        "Using AngularDart for web development",
        "Client-server communication with Dart",
        "Working with web APIs"
        ]
        },
        {
        title: "Desktop and Mobile App Development with Dart",
        content: [
        "Introduction to Flutter",
        "Building mobile apps with Flutter",
        "Flutter widgets and layouts",
        "Handling user input in Flutter",
        "Navigation and routing in Flutter"
        ]
        },
        {
        title: "Database Access with Dart",
        content: [
        "Introduction to database access with Dart",
        "Working with SQLite databases",
        "Using the Dart ORM",
        "Accessing databases using HTTP requests",
        "Securing database access in Dart"
        ]
        },
        {
        title: "Testing and Debugging in Dart",
        content: [
        "Unit testing in Dart",
        "Integration testing in Dart",
        "Debugging Dart code",
        "Using logging in Dart",
        "Performance optimization in Dart"
        ]
        },
        {
        title: "Deployment and Continuous Integration with Dart",
        content: [
        "Deploying Dart applications",
        "Continuous integration with Dart",
        "Using Jenkins for CI/CD with Dart",
        "Creating Docker images for Dart applications",
        "Working with cloud platforms for Dart"
        ]
        }
        
    ]

    const faqData = [
      {
        question: 'What is Dart?  ',
        answer:
          'Dart is an open-source, object-oriented programming language developed by Google. It is designed to be simple, efficient, and scalable, making it suitable for building a wide range of applications, from mobile apps to web applications and server-side programs.',
      },
      {
        question: 'Is Dart only used for Flutter development? ',
        answer:
          'No, Dart is not limited to Flutter development. While it is the primary language used in the Flutter framework for building cross-platform mobile apps, Dart can also be used for web development, server-side programming, and even desktop applications.',
      },
      {
        question: 'What are some popular data programming frameworks and libraries?',
        answer:
          'Some popular data programming frameworks and libraries include Apache Spark, Apache Hadoop, TensorFlow, PyTorch, Pandas, NumPy, and Scikit-learn.',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with data programming skills can pursue a variety of career opportunities such as Data Scientist, Data Analyst, Machine Learning Engineer, Business Intelligence Developer, and Data Engineer.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"To attend our Dart course, you should know the basics of programming like variables, loops, conditionals, and functions. You need strong problem-solving skills and logical thinking abilities to write good code. Dart is a flexible language used in many applications, so you must be eager to explore what it can do and learn about its newest updates. While not required, having an interest in Flutter development will be helpful since Dart is the main language used for Flutter."
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
     return(
      <>
      
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Dart is a client-optimized language for developing fast apps on any platform. Its goal is to offer the most productive programming language for multi-platform development, paired with a flexible execution runtime platform for app frameworks."/> */}
           
          <NewMainsec rating='4.8' students={"675"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro={`Dart is a client-optimized language for developing fast apps on any platform. Its goal is to offer the most productive programming language for multi-platform development, paired with a flexible execution runtime platform for app frameworks.`}/>
          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Learnsoft.org is a leading provider of Dart Programming ${this.props.location1}, designed to equip individuals with the skills and knowledge necessary to succeed in the fast-paced world of software development. Our expert trainers provide hands-on instruction in Dart programming, teaching you everything you need to know to become a proficient developer. With our comprehensive curriculum, you'll gain an in-depth understanding of Dart syntax, object-oriented programming concepts, and more.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Dart Programming course covers all the essential topics, including Dart basics, functions, control structures, classes, and more. With our expert guidance, you'll learn how to develop high-performance web applications using the Dart programming language. You'll also gain experience with popular web frameworks like AngularDart, and learn how to use the Flutter framework to build mobile apps."}/>
           </section>
 <Batchtime title={this.props.title} fees="20,999" offer="12,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>     
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="Java" coupath2="java" cou3='R Programming' coupath3='rprogram' cou10='Full Stack Developer' coupath10='full-stack-developer' cou6='AngularJS' coupath6='angularjs' cou9='Front End Developer' coupath9='front-end-developer'
          cou5='ReactJS' coupath5='reactjs' cou='JavaScript' coupath='javascript' cou7='Katalon' coupath7='katalon'
          cou1='Python' coupath1='python' cou8='flutter' coupath8='flutter'  cou4='Go' coupath4='go' />
        
      </>
    );
  }
}
